// src/components/CustomDropzone.js
import React from "react";
import { useDropzone } from "react-dropzone";

const CustomDropzone = ({ onDrop, file }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*,application/pdf",
  });

  return (
    <div
      {...getRootProps()}
      className="border-solid border border-[#9E9E9E] rounded py-3 px-4 flex  items-center cursor-pointer w-[683.89px]"
    >
      <input {...getInputProps()} />
      {file ? (
        <p>{file.name}</p>
      ) : (
        <p className="font-[300] pt-1">Click to upload</p>
      )}
    </div>
  );
};

export default CustomDropzone;
